import React from 'react';
import styled from 'styled-components';
import useNavigationStore from '../state-hook';

const Container = styled.div`
  margin-top: 32px;
`;

export default function Preview() {
  const items = useNavigationStore(state => state.items);

  return (
    <Container className="application-navbar">
      <div className="application-navbar-inner">
        <ul className="application-navbar-primary-navigation">
          {items.filter(item => item.name?.trim() && item.url?.trim()).map(item => (
            <li className="plain" key={item.order}>
              <a className="menu" href={item.url}>{item.name}</a>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
}
